export enum BundlePackStatus {
  PendingPayment = 'pending-payment',
  Active = 'active',
  Exhausted = 'exhausted',
  Expired = 'expired',
  Cancelled = 'cancelled'
}

export interface IBundlePackRedemption {
  appointmentId: string;
  redeemedAt: Date | string;
  serviceId: string;
}

export interface ICustomerBundlePack {
  _id?: string;
  bid: string;
  templateId: string;
  templateName?: string;
  customerId: string;
  serviceIds: string[];
  totalUses: number;
  remainingUses: number;
  price: number;
  purchasedAt?: Date | string;
  expiresAt?: Date | string;
  status: BundlePackStatus;
  redemptions: IBundlePackRedemption[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ICustomerBundlePackWithCustomer extends ICustomerBundlePack {
  customerName?: string;
  customerPhone?: string;
}
